/**
 * The Lifelong mark, inline so it paints with the first frame. Brand greens are fixed, not theme
 * tokens: the logo looks the same on both themes. Source vector: docs/slack-app-icon.svg.
 */
export function Mark({ className = 'size-8' }: { className?: string }) {
  return (
    <svg viewBox="0 0 500 500" className={`shrink-0 ${className}`} aria-hidden focusable="false">
      <defs>
        <linearGradient id="lsc-mark-mid" gradientUnits="userSpaceOnUse" x1="341" y1="400" x2="456" y2="400">
          <stop offset="0" stopColor="#309D18" />
          <stop offset="1" stopColor="#1E620E" />
        </linearGradient>
      </defs>
      <g transform="translate(-150 -150) rotate(45 400 400)">
        <rect x="253" y="255" width="63" height="262" rx="14" fill="#309D18" />
        <rect x="253" y="458" width="200" height="59" rx="14" fill="#309D18" />
        <rect x="347" y="285" width="200" height="62" rx="14" fill="#1E620E" />
        <rect x="484" y="285" width="63" height="261" rx="14" fill="#1E620E" />
        <rect x="341" y="367" width="116" height="66" rx="12" fill="url(#lsc-mark-mid)" />
      </g>
    </svg>
  );
}
